<script setup lang="ts">
import FormCheck from '../FormCheck';
</script>

<template>
  <FormCheck>
    <slot></slot>
  </FormCheck>
</template>
